<div class="gs-modal">
    <div class="gs-modal__content">
        <div class="text-center">
            <h5 class="mb-3">Do you delete this spotlight?</h5>
            <div class="btn btn-gray-light mx-1"(click)="Cancel()">No</div>
            <a href="javascript:void(0)" (click)="deleteSpotlight()" class="btn btn-pink mx-1">Yes</a>
        </div>
    </div>
</div>
